<template>
  <v-btn
    :loading="submit_loading"
    :disabled="submit_loading"
    :color="color"
    class="white--text text-none"
    @click="submitFunction"
    :text="just_text"
    large
  >
    {{ text }}
  </v-btn>
</template>
<script>
  export default {
    name: 'submitButton',
    props: ['submitFunction', 'submit_loading', 'text', 'color', 'just_text', 'small'],
  }
</script>
